import { render } from "./ZhaiThreeTuttons.vue?vue&type=template&id=7afd2868&scoped=true"
import script from "./ZhaiThreeTuttons.vue?vue&type=script&lang=js"
export * from "./ZhaiThreeTuttons.vue?vue&type=script&lang=js"

import "./ZhaiThreeTuttons.vue?vue&type=style&index=0&id=7afd2868&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7afd2868"]])

export default __exports__